import React, { useContext } from 'react';
import clsx from "clsx";
import { Avatar } from '@mui/material';
import useStyles from "../../style/js-style/components/common/EAAvatarStyle";
import { Context } from '../../states/Store';

function EAAvatar({ userName, variant = "default", size = 35, fontSize = "0.875rem", disabled = false, ...other}) {
  const { classes } = useStyles();
  const [state] = useContext(Context)

  function stringAvatar() {
    let name = userName;
    let initials = "";
    if (name.split(' ').length > 1) {
      initials = `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`
    } else {
      initials = `${name.split(' ')[0][0]}`;
    }
    return {
      sx: {
        width: size,
        height: size,
        fontSize: fontSize,
        fontWeight: 700,
      },
      children: initials,
    };
  }

  function chooseClassName(variant) {
    let resClass;
    if (variant === "admin") {
      resClass = clsx(classes.circleShapeAdmin, classes.userInitialsAdmin);
    } else if (variant === "display-note") {
      resClass = clsx(classes.circleShapeGrey, classes.userInitialsGrey);
    } else {
      resClass = clsx(classes.circleShape, classes.userInitials);
    }
    if(disabled) {
      resClass = clsx(resClass, classes.disabledAvatar)
    }
    return resClass;
  }

  return (
    <>
      {userName && (
        <div>
          <Avatar
            {...stringAvatar()}
            className={chooseClassName(variant)}
            style={{
              backgroundColor:
                variant === "default"
                  ? state.personalization.isCustomTemplate ? state.personalization.colorPrimary : "#B0E8B9"
                  : variant === "admin" ? "white" : "",
              color:
                (state.personalization.isCustomTemplate && variant !== "admin")
                  ? "white"
                  : state.personalization.isCustomTemplate ? state.personalization.colorPrimary: "#003A22",
              opacity: variant === "default" ? 0.7 : 1,
              cursor: variant === "default" || variant === "admin" ? "pointer" : ""
            }}
            {...other}
          />
        </div>
      )}
    </>
  );
}

export default EAAvatar;
